import { useForm, SubmitHandler } from 'react-hook-form';
import { useSupabase } from '@/components/providers/SupabaseProvider';
import SubmitButton from '@/components/buttons/SubmitButton';

type Inputs = {
  email: string;
};

type Props = {
  submitButtonText: string;
  onSuccess: (email: string) => void;
};

export default function RequestOtpForm({ submitButtonText, onSuccess }: Props) {
  const supabase = useSupabase();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async ({ email }) => {
    const result = await supabase.supabase.auth.signInWithOtp({
      email,
    });

    if (result.error === null) {
      onSuccess(email);
    } else {
      console.error(result.error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
      <input
        {...register('email', { required: true })}
        type="email"
        required
        placeholder="Email"
        className="input mb-3"
      />

      <SubmitButton title={submitButtonText} isSubmitting={isSubmitting} />
    </form>
  );
}
